import React from 'react';
import { CheckboxLogin } from './styles';
import useFormType from '../../../hooks/useFormType';

/**
 * @param props
 * @param {String} props.name
 * @param {String} props.label
 */
export default function Checkbox({ name, label, ...rest }) {
  const { ref, defaultValue } = useFormType(name, 'checked');

  return (
    <CheckboxLogin>
      <input
        ref={ref}
        checked={defaultValue}
        {...rest}
        type="checkbox"
        id={name}
      />
      <label htmlFor={name}>{label}</label>
    </CheckboxLogin>
  );
}
